export const errorRoutes = [
  {
    path: "/*",
    name: "not_found",
    component: () => import("@/modules/errors/404/404View.vue"),
  },
];
